import { useEffect } from 'react'
import useSWR from 'swr'

import fetcher from '../../lib/fetcher'
import { useCampaign } from '../use-campaign'

interface Referrer {
  slug: string
}

export function useReferral(slug: string) {
  const campaign = useCampaign()
  const { data, error } = useSWR<Referrer>(
    campaign?.campaign?.id ? `/campaigns/${campaign.campaign.id}/referrers/${slug}` : null,
    fetcher.api
  )

  useEffect(() => {
    if (error) {
      console.error(`🔴 Error getting referral ${slug}`, { error, data })
    }
  }, [error, data, slug])

  if (!campaign.campaign) {
    return { ...campaign, slug: undefined }
  }

  return {
    campaign: campaign.campaign,
    slug: data?.slug,
    isLoading: !error && !data,
    error,
  }
}
